import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { primitive } from 'styles/constants/primitives';

export const StyledResetButton = styled(ActionButton)`
  background-color: ${primitive.$white};
`;
